import { TargetsTab } from "./TargetsTab";

export default TargetsTab;
